export default {
  amplitudeKey: process.env.REACT_APP_AMPLITUDE_KEY,
  analyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
};
